<template>
  <!--<transition mode="out-in"-->
  <!--enter-active-class="animated zoomInUp"-->
  <!--leave-active-class="animated zoomOutDown">-->
  <div style="width:100%">

    <!--主图-->
    <div class="mainImg">
      <img src="../assets/hardwareShow.jpg" alt="产品展示">
    </div>

    <!--产品展示-->
    <div v-for="(value,index) in  goodsList">
      <!--启明硬件-->
      <div class="qiming-eye" :id="value.productId" v-if="index%2===0">
        <Row>
          <Col :xs="24" :sm="24" :md="8" :lg="8" style="text-align: center">
          <!--视频播放-->
          <div class="video" style="margin:30px 0 30px 150px">
            <video-player class="vjs-custom-skin"
                          :options="playerOptions[index]"></video-player>
          </div>
          </Col>
          <!--<img src="../assets/hardware2.jpg" alt="启明硬件图片" class="productPic"></Col>-->
          <Col :xs="24" :sm="24" :md="5" :lg="5" >&emsp;</Col>
          <Col :xs="24" :sm="24" :md="11" :lg="11" class="detailInfo">
          <Row class="productTitle"><Col>{{value.productTitle}}</Col></Row>
          <Row class="productInfo"><Col>{{value.productDescribe}}</Col></Row>
          </Col>
        </Row>
      </div>

      <div class="qiming-FM" :id="value.productId"  v-if="index%2!==0">
        <Row style="text-align: right">
          <Col :xs="24" :sm="24" :md="11" :lg="11" class="detailInfo2">
          <Row class="productTitle"><Col>{{value.productTitle}}</Col></Row>
          <Row class="productInfo2"><Col>{{value.productDescribe}}</Col></Row>
          </Col>
          <Col :xs="24" :sm="24" :md="5" :lg="5">&emsp;</Col>
          <Col :xs="24" :sm="24" :md="8" :lg="8" style="text-align: center">
          <div class="video" style="margin:30px 150px 20px 0">
            <video-player class="vjs-custom-skin" :options="playerOptions[index]"></video-player>
          </div>
          </Col>
        </Row>
      </div>
    </div>

    <!--页脚-->
    <div class="footer">
      <ul style="display: flex;align-items: center;flex-direction: column;list-style: none;justify-content: center; height: 100%">
        <li class="info">Copyright © 2017-2020 All rights reserved 版权所有 © 无障碍科技有限公司</li>
        <li class="info">备案号：鄂ICP备18005954号</li>
      </ul>
    </div>

  </div>
  <!--</transition>-->
</template>

<script>
  import 'video.js/dist/video-js.css'
  import 'vue-video-player/src/custom-theme.css'
  //引入hls.js
  import 'videojs-contrib-hls.js/src/videojs.hlsjs'
  export default {
    name: "community",
    data(){
      return{
        // playerOptions: {
        //   playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        //   autoplay: false, //如果true,浏览器准备好时开始回放。
        //   controls: true, //控制条
        //   preload: 'auto', //视频预加载
        //   muted: false, //默认情况下将会消除任何音频。
        //   loop: false, //导致视频一结束就重新开始。
        //   language: 'zh-CN',
        //   aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        //   fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        //   sources: [{
        //     type: 'video/mp4',
        //     src: 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4'
        //   }],
        //   poster: "http://static.smartisanos.cn/pr/img/video/video_03_cc87ce5bdb.jpg"//你的封面地址
        // },
        playerOptions:[],
        goodsList:[]//产品列表
      }
    },
    methods:{
      androidDown(){
        //TODO 安卓下载
      },//安卓下载
      iosDown(){
        //TODO ios下载
      },//ios下载
      gotoDetail(){
        let goodid="#"+this.$route.query.goodID;
        if(this.$route.query.goodID!==undefined){
          document.querySelector(goodid).scrollIntoView(true);
        }
      },//从首页点击产品跳转过来的时候，自动跳转到产品的详情位置
      getData(){
        this.$http.get('/zm/WMWebsite/queryProductInfos ').then(res=>{
          this.goodsList=[];
          let i;
          for(i=0;i<res.data.content.length;i++){
            if(res.data.content[i].appid===""){
              this.goodsList.push(res.data.content[i]);
              this.playerOptions.push({
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                controls: true, //控制条
                preload: 'auto', //视频预加载
                muted: false, //默认情况下将会消除任何音频。
                loop: false, //导致视频一结束就重新开始。
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                  type: 'video/mp4',
                  src: res.data.content[i].playerSrc,
                }],
                poster: res.data.content[i].posterSrc//你的封面地址
              })
            }
          }
        })
      }//获取产品列表信息
    },
    watch: {
      'goodsList': function () {
        this.$nextTick(function () {
          this.gotoDetail();
        })
      }
    },
    activated() {
      this.getData();
    }
  }
</script>

<style scoped>
  .mainImg img{
    width: 100%;
    height: 600px;
  }/*主图*/
  .productPic{
    width: 300px;
    height: 300px;
    margin: 3% 0;
  }/*产品的图片*/
  .productTitle{
    font-weight: bold;
    font-size: 2.0rem;
    margin-top: 5%;
    color: rgba(63, 175, 174, 1);
  }/*产品的名称*/
  .productInfo{
    font-size: 1.2rem;
    text-indent: 2em;
    width: 60%;
    margin-top: 3%;
    color: rgba(63, 175, 174, 1);
  }/*产品的介绍*/
  .productInfo2{
    margin-top: 3%;
    font-size: 1.2rem;
    color: rgba(63, 175, 174, 1);
    text-indent: 2em;
  }
  .detailInfo{
    text-align: left;
    padding-left:20px;
    height: 270px;
    background: rgba(63, 175, 174, 0.4);
    background: -moz-linear-gradient(right,  rgba(63, 175, 174, 0.4) 0%, white 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(63, 175, 174, 0.4)), color-stop(100%,white));
    background: -webkit-linear-gradient(right,  rgba(63, 175, 174, 0.4) 0%,white 100%);
    background: -o-linear-gradient(right,  rgba(63, 175, 174, 0.4) 0%, white 100%);
    background: -ms-linear-gradient(right,  rgba(63, 175, 174, 0.4) 0%, white 100%);
    background: linear-gradient(to left,  rgba(63, 175, 174, 0.4) 0%,white 100%);
  }
  .detailInfo2{
    height: 270px;
    padding-right: 20px;
    background: rgba(63, 175, 174, 0.4);
    background: -moz-linear-gradient(left,  rgba(63, 175, 174, 0.4) 0%, white 100%);
    background: -webkit-gradient(linear, right top, left bottom, color-stop(0%,rgba(63, 175, 174, 0.4)), color-stop(100%,white));
    background: -webkit-linear-gradient(left,  rgba(63, 175, 174, 0.4) 0%,white 100%);
    background: -o-linear-gradient(left,  rgba(63, 175, 174, 0.4) 0%, white 100%);
    background: -ms-linear-gradient(left,  rgba(63, 175, 174, 0.4) 0%, white 100%);
    background: linear-gradient(to right,  rgba(63, 175, 174, 0.4) 0%,white 100%);
  }
  .Download {
    margin-top: 3%;
  }/*下载按钮*/
  .qiming-FM{
    /*background-color: #CCCCCC;*/
  }/*启明Fm背景色*/
  .footer{
    background-color: rgba(57, 207, 204, 1);
    text-align: center;
    width: 100%;
    height: 130px;
  }/*页脚*/
  .footer .info{
    color:#fff;
    font-size:0.8rem;
  }/*页脚：里面的内容*/


  /*手机竖屏*/
  @media only screen
  and (min-width: 320px)
  and (max-width: 767px)
  and (orientation: portrait){
    .mainImg img{
      height: 200px;
      margin-top:1%;
    }
  }

  /*手机横屏*/
  @media only screen
  and (min-width: 320px)
  and (max-width: 767px)
  and (orientation: landscape){
    .mainImg img{
      height: 300px;
      margin-top:1%;
    }
  }

  /*平板竖屏*/
  @media only screen
  and (min-width: 768px)
  and (max-width: 1024px)
  and (orientation: portrait){
    .mainImg img{
      height: 400px;
      margin-top:2%;
    }
  }

  /*平板横屏*/
  @media only screen
  and (min-width: 768px)
  and (max-width: 1024px)
  and (orientation: landscape){
    .mainImg img{
      height: 400px;
      margin-top:2%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hardware.vue